import axios from 'axios';

class LoginService {

    getJWT(username, password){ 
        //return axios.get("https://testauthentication.case-gs.eu/authentication_server/UserBean.action?username="+username+"&password="+password);
        
        return axios.get(process.env.AUTHENTICATION_SERVER_URL + "/UserBean.action?username="+username+"&password="+password);
    }

    loadJWT(jwtKey){
        //return axios.get("https://oauthtest.case-gs.eu/auth/loadJWT/" +jwtKey);
        return axios.get(process.env.OAUTH2_CLIENT_URL + "/auth/loadJWT/" +jwtKey);
    }
}

export default new LoginService()